module.exports = __webpack_public_path__ + "8a3ee07590a37863c19ecbdf74f96c5a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/annotated-example-3.png
// module id = 1717
// module chunks = 0